import { UseDataProviderProps, GroupTotalsProps } from "../.."
import { DataItemProps } from "../../ConfigurableLineChart.types"

export const valueKeyTotals = ({ data, valueKey, attachItems, attachIndexes = true, valueKeys, groupKey, includeKeys, renameKeys }: UseDataProviderProps): GroupTotalsProps | undefined => 
data && Array.from(data)?.reduce((acc: GroupTotalsProps, item: DataItemProps, dataIndex: number) => {
 
  valueKeys = (valueKeys || []) as [keyof DataItemProps]
  if (valueKey) valueKeys.push(valueKey as keyof DataItemProps)

  valueKeys?.forEach((key: keyof DataItemProps) => {
    const value = Number(item?.[key])
    if (typeof value !== 'number') return acc
    if (!acc?.[key]) acc = {...acc, [key]: { count: 0, total: 0, average: 0, low: value || 0, high: value || 0, value, [key]: value, valueKey: key }}
    if (groupKey) acc[key] = {...acc[key], [(groupKey || 'group') as keyof DataItemProps]: item?.[groupKey as keyof DataItemProps] || value }

    ++(acc[key].count as number)

    if (attachItems) {
      if (!acc[key].items) acc[key].items = []
      acc[key].items = [...acc[key].items, item]
    } 

    if (attachIndexes) {
      if (!acc[key].items) acc[key].indexes = []
      acc[key].indexes = [...(acc[key].indexes as number[]), dataIndex]
    }

    if (includeKeys) {
 
      includeKeys?.forEach((key2: keyof DataItemProps) => {  
        const value2 = item?.[key2]
 
        if (value2) acc[key] = {...acc[key], [key2]: value2}
      })
    }
    
    if (typeof value === 'number') {
      acc[key].total = (acc[key].total as number) + value
      acc[key].average = (acc[key].total as number) / (acc[key].count as number)
      if (value < (acc[key].low as number)) acc[key].low = value
      if (value > (acc[key].high as number)) acc[key].high = value
    } else if (value instanceof Date) {
      const dateVal = value.getTime()
      if (dateVal < (acc[key].low as number)) acc[key].low = dateVal
      if (dateVal > (acc[key].high as number)) acc[key].high = dateVal
    }
 

    if (renameKeys) Object.entries(renameKeys)?.forEach(([oldKey, newKey]) => {
      if (acc[key]?.[oldKey]) {
        acc[key] = {...acc[key], [newKey]: acc[key][oldKey] }
        delete acc[key][oldKey]
      }
    })
    
  })   
  return acc
},{}) as GroupTotalsProps
